// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1NJMM","name":"ConsentHeader_name__2_S6S","birthday":"ConsentHeader_birthday__3NLbw","skeleton":"ConsentHeader_skeleton__1Y7tR"};